// extracted by mini-css-extract-plugin
module.exports = {"container":"ProposedSummary_container__2HJEl","avatars":"ProposedSummary_avatars__2dBZM"};